import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { IconButton } from '@perch-labs/shrike';

export const CloseButton = styled(IconButton)`
  position: absolute;
  display: block;
  top: 0;
  right: 0;
`;

export const ButtonWrapper = styled.div`
  position: relative;
`;

export const StyledSVG = styled(SVG).attrs({
  width: '70px',
  height: '70px',
  'aria-hidden': true,
})`
  margin-top: 16px;
  margin-bottom: 42px;
`;
